import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as globalReducer from "containers/App/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

import SubView from "components/View/SubView";

import WarningBanner from "containers/WarningBanner/WarningBanner";

import ChatsTile from "components/Tiles/ChatsTile";

class ChatsViewContainer extends React.Component {
  getHeaders() {
    return ["Project", "Creation", "Contributors", "Subgroups", "Created By"];
  }

  render() {
    const {
      data,
      deleteReport,
      handleExplorationPin,
      handleMoveReport,
      history,
      pinnedExplorations,
      isReportsLoading,
      selectedFolder,
      isTableauMode,
      lookerSDK,
      setIsLoading,
      switchTabToGPT,
      getChatMetrics
    } = this.props;

    const fData = data.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));

    const orderedData = data.sort((a, b) =>
      pinnedExplorations?.[a?.id] !== undefined && pinnedExplorations?.[b?.id] === undefined
        ? -1
        : pinnedExplorations?.[a?.id] === undefined && pinnedExplorations?.[b?.id] !== undefined
          ? 1
          : pinnedExplorations?.[a?.id] !== undefined && pinnedExplorations?.[b?.id] !== undefined
            ? pinnedExplorations?.[a?.id] > pinnedExplorations?.[b?.id]
              ? 1
              : pinnedExplorations?.[a?.id] < pinnedExplorations?.[b?.id]
                ? -1
                : 0
            : a.created > b.created
              ? -1
              : a.created < b.created
                ? 1
                : 0
    );

    return (
      <React.Fragment>
        {isTableauMode ? <WarningBanner type="aible_tableau_projects_warning" /> : <React.Fragment />}
        <SubView
          {...this.props}
          label="Exploration"
          headers={this.getHeaders()}
          firstTile={<div />}
          firstRow={<div />}
          length={data.length}
          isInfinite={true}
          isLoading={selectedFolder !== undefined && isReportsLoading}
          tileHeight={315}
          renderTile={(columnIndex, style) => {
            const fNext = orderedData[columnIndex].metadata.next
              ? orderedData[columnIndex].metadata.next
              : orderedData[columnIndex].metadata.explorations &&
                  Object.keys(orderedData[columnIndex].metadata.explorations).length > 0
                ? orderedData[columnIndex].metadata.explorations[0]
                : {};
            return data && data.length > columnIndex ? (
              <div style={style} key={columnIndex}>
                <ChatsTile
                  /*
                  onClick={() =>
                    history.push(
                      "/next/" +
                        fNext?.datasetId +
                        "/" +
                        orderedData[columnIndex].id
                    )
                  }
                  */
                  onClick={() => {
                    setIsLoading();
                    switchTabToGPT();
                    history.push(
                      isTableauMode || lookerSDK !== undefined
                        ? "/project_next/" + orderedData[columnIndex]?.id
                        : "/next/" + fNext?.datasetId + "/" + orderedData[columnIndex].id
                    );
                  }}
                  handleMoveReport={(reportId, folderId) => handleMoveReport(reportId, folderId)}
                  handleDelete={() => deleteReport(orderedData[columnIndex].id)}
                  handlePin={() => handleExplorationPin(orderedData[columnIndex].id)}
                  pinnedExplorations={pinnedExplorations}
                  data={orderedData[columnIndex]}
                  getChatMetrics={getChatMetrics}
                />
              </div>
            ) : undefined;
          }}
          childrenLength={data.length}
        ></SubView>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(reportReducer.fetchNextReports()),
  fetchAll: () => dispatch(reportReducer.fetchAllReports()),
  deleteReport: (id) => dispatch(reportReducer.deleteReport(id)),
  handleMoveReport: (reportId) => dispatch(foldersReducer.handleMoveReport(reportId)),
  moveReportFolder: (reportId, folderId) => dispatch(foldersReducer.moveReportFolder(reportId, folderId)),

  handleExplorationPin: (id) => dispatch(viewReducer.updateExplorationPin(id)),
  setIsLoading: () => dispatch(globalReducer.updateIsNextLoading(true)),

  switchTabToGPT: () => dispatch(globalReducer.updateShouldSwitchToGPT(true)),

  getChatMetrics: (convArr) => dispatch((dispatch, getState) => chatGPTReducer.getChatMetrics(getState(), convArr))
});

const mapStateToProps = (state, ownProps) => {
  return {
    data: viewReducer.getReports(state),
    isTile: viewReducer.getIsTile(state),
    isReportsLoading: globalReducer.getIsReportsLoading(state),
    type: viewReducer.getType(state),
    selectedFolder: foldersReducer.getSelectedFolder(state),

    isTableauMode: globalReducer.getIsTableauMode(state),

    pinnedExplorations: viewReducer.getPinnedExplorations(state),

    lookerSDK: loginReducer.getLookerAPIClient(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ChatsViewContainer);
